export const projects = [
  {
    id: 1,
    img: "https://iili.io/yxPurN.md.png",
    title: "Website Film",
    description: `This project is special to me because its first time i do 1 project using Reactjs.`,
    tags: ["React", "Bootstraps", "Router Dom V6"],
    liveLink: "http://dhh-film.vercel.app/",
    ghLink: "",
  },
  {
    id: 2,
    img: "https://iili.io/HXqcSp4.jpg",
    title: "Website Music",
    description: `This project is made with all my love <3 `,
    tags: ["ReactJs", "Redux", "Tailwind ", "JavaScript"],
    liveLink: "https://dhh-zingmp3.vercel.app/",
    ghLink: "",
  },
  {
    id: 3,
    img: "https://iili.io/yTmtrF.md.png",
    title: "Website Comic",
    description: `This project i just use HTML, CSS, Bootstrap, JS to coding`,
    tags: ["HTML", "CSS", "Bootstrap ", "JavaScript"],
    liveLink: "https://dhh-manga.vercel.app",
    ghLink: "",
  },
  {
    id: 4,
    img: "https://iili.io/yxi8ts.md.png",
    title: "Portfolio Website",
    description: `This project is the very first project I built after breaking out of the tutorial hell. I got inspired by many great developers I have learned from Youtube, Udemy & Freecodecamp.`,
    tags: ["React", "CSS"],
    liveLink: "https://dhh-portfolio.vercel.app/",
    ghLink: "",
  },
];
